import { inventoryProductService } from "../../../../../Api/Services/InventoryService/inventoryProduct";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { IInventoryActionOtpPayload, IInventoryActionOtpResponse } from "../../types";


// --- Thunk ---
export const sendInventoryActionOtp = createServiceAsyncThunk<
  IInventoryActionOtpResponse,
  IInventoryActionOtpPayload
>(
  ACTION_NAMES.SEND_INVENTORY_ACTION_OTP,
  (payload) => inventoryProductService.sendInventoryActionOtp(payload),
  ERROR_MESSAGES.SEND_INVENTORY_ACTION_OTP_FAILURE
);

// --- Slice ---
const sendInventoryActionOtpSlice = createGenericSlice<
  IInventoryActionOtpResponse,
  IInventoryActionOtpPayload
>(
  SLICE_NAMES.SEND_INVENTORY_ACTION_OTP_SLICE,
  sendInventoryActionOtp
);

export const {
  clearError: clearSendInventoryActionOtpError,
  clearSuccessMessage: clearSendInventoryActionOtpSuccessMessage,
} = sendInventoryActionOtpSlice.actions;

export default sendInventoryActionOtpSlice.reducer;
